const ASSET_ROOT = '/competitive-intelligence/logos'

const SOURCE_LOGOS = {
  pubmed: 'pub-med-logo.png',
  'clinical-trials': 'clinical-trial-logo.jpg',
  fda: 'fda-510k-cleared-510-k-logo.png',
  linkedin: 'linkedin-logo.webp',
  instagram: 'instagram.jpg',
}

const COMPETITOR_LOGOS = {
  brainsway: 'BrainsWay-logo.webp',
  magstim: 'Magstim-Logo.png',
  neuronetics: 'neuronetics_logo.png',
  deymed: 'Deymed_logo.jpg',
  neurosoft: 'Neurosoft-logo.png',
  magandmore: 'MagAndMore-logo.png',
  'mag&more': 'MagAndMore-logo.png',
  btl: 'BTL_Logo.png',
  btl_brain: 'BTL_Logo.png',
  btl_rehab: 'BTL_Logo.png',
  yingchi: 'Yingchi-logo.jpg',
}

const normalize = value => String(value || '').trim().toLowerCase().replace(/\s+/g, '')

export const sourceLogo = value => SOURCE_LOGOS[String(value || '').trim().toLowerCase()]
  ? `${ASSET_ROOT}/${SOURCE_LOGOS[String(value || '').trim().toLowerCase()]}`
  : null

export const competitorLogo = value => COMPETITOR_LOGOS[normalize(value)]
  ? `${ASSET_ROOT}/${COMPETITOR_LOGOS[normalize(value)]}`
  : null
